export default __webpack_public_path__ + "static/media/submit-test-tune.41a7d01d.mp3";